import JAT1 from '../assets/images/thumbnails/JAH1.png'
import JAP1T from '../assets/images/preview/JAH1P.png'
import JAT2 from '../assets/images/thumbnails/JAH2.png'
import JAP2T from '../assets/images/preview/JAH2P.png'

import JALogo from '../assets/images/logo/LogoJA.png'

const Jueguemos = [
  {
    id: 1,
    section: 'Jueguemos2',
    title: 'Jueguemos a: Minecraft Hardcore Parte 1',
    thumbnailUrl: JAT1,
    webUrl: 'https://www.youtube.com/embed/7Q4ek7X8QeQ', // Add the episode URL
    backgroundImage: JAP1T,
    seriesLogo: JALogo,
    description: 'Iniciamos con esta madre!',
  },
  {
    id: 2,
    section: 'Jueguemos2',
    title: 'Jueguemos a: Minecraft Hardcore Parte 2',
    thumbnailUrl: JAT2,
    webUrl: 'https://www.youtube.com/embed/v9ELzficyFc', // Add the episode URL
    backgroundImage: JAP2T,
    seriesLogo: JALogo,
    description: 'Seguimos con esta madre!',
  },
  ];

  export default Jueguemos;
